<template>
  <div v-if="display">
    <modal-layout-top :title="title" />
    <div class="content slider-modal">
      <h4>Taxa</h4>
      <div class="field is-horizontal" v-for="item in priceList.lines.filter(x => x.productType === 'Rate')" :key="item.productId">
        <div class="field-body">
          <div class="field is-grouped">
            <div class="field-label">
              <label class="label">{{ item.productName }}</label>
            </div>
            <p class="control is-expanded">
              <input type="number" class="input" v-model="item.price">
            </p>
          </div>
        </div>
      </div>

      <h4>Hyra</h4>
      <div class="field is-horizontal" v-for="item in priceList.lines.filter(x => x.productType === 'Rent')" :key="item.productId">
        <div class="field-body">
          <div class="field is-grouped">
            <div class="field-label">
              <label class="label">{{ item.productName }}</label>
            </div>
            <p class="control is-expanded">
              <input type="number" class="input" v-model="item.price">
            </p>
          </div>
        </div>
      </div>

      <modal-layout-buttons :store-name="'priceListProject'" />
    </div>

  </div>
</template>

<script>

import { mapActions } from 'vuex'
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'

export default {
  name: 'price-list-project-modal',
  data () {
    return {
      project: { },
      priceList: { },
      display: false
    }
  },
  components: {
    ModalLayoutTop,
    ModalLayoutButtons
  },
  props: {
    projectId: {
      type: Number,
      required: true
    }
  },
  computed: {
    title () {
      return 'Prislista ' + this.project.projectCode
    }
  },
  methods: {
    ...mapActions('priceListProject', ['savePriceList', 'getByProjectId']),
    ...mapActions('projects', ['getById']),

    closePanel () {
      this.$emit('closePanel')
    },

    save () {
      const priceMissing = this.priceList.lines.filter(x => !x.price)

      if (priceMissing && priceMissing.length > 0) {
        this.$toast('Fyll i samtliga priser (' + priceMissing.length + ' priser saknas)', 'error')
        return
      }

      this.savePriceList(this.priceList).then(() => {
        this.closePanel()
      })
    }
  },

  created () {
    this.$on('emitSave', () => {
      this.save()
    })

    console.log('CREATED!!!!!')

    let promises = []

    promises.push(this.getByProjectId(this.projectId).then((priceList) => {
      this.priceList = priceList
    }))

    promises.push(this.getById(this.projectId).then((project) => {
      this.project = project
    }))

    Promise.all(promises).then(() => {
      this.display = true
    })
  }
}
</script>

<style soped>
  .field-body {
    margin-top: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/PriceListProjectModal.vue